module.exports = __webpack_public_path__ + "img/visa.6386c39e.svg";